import {
  ActiveFilterPillBar,
  AlertCountBadge,
  AlertDot,
  ColumnPicker,
  ColumnResizeHandle,
  DEFAULT_MIN_COLUMN_WIDTH,
  DrawerShell,
  FilterBuilderDrawer,
  FilterConditionRow,
  MAX_FILTER_NESTING_DEPTH,
  OPERATORS_BY_FIELD_TYPE,
  OPERATOR_LABELS,
  SearchInput,
  SectionHeader,
  SortBuilder,
  TablePageShell,
  TableToolbar,
  appendChildToGroup,
  applySorts,
  canNestDeeper,
  clampColumnWidth,
  clearFilterTree,
  columnVisibilityStorageKey,
  columnWidthsStorageKey,
  countFilterConditions,
  createBooleanSearchEvaluator,
  createEmptyFilterGroup,
  createFilterCondition,
  createId,
  createTablePersistence,
  evaluateBooleanSearch,
  evaluateCondition,
  evaluateFilterTree,
  filterRows,
  generateFilterPills,
  getDefaultOperatorForFieldType,
  getFilterTreeDepth,
  getOperatorsForFieldType,
  getStickyLeftOffset,
  getTotalColumnWidth,
  GroupBySelect,
  HoverHelp,
  isFilterCondition,
  isFilterGroup,
  isRenderableFilterNode,
  loadColumnWidths as loadColumnWidthsBase,
  matchTerm,
  mergeColumnWidths,
  operatorAcceptsMultipleValues,
  operatorRequiresValue,
  parseSearchQuery,
  readStoredColumnWidths as readStoredColumnWidthsBase,
  removeFilterNode,
  removeFilterPill,
  resolveFieldValue,
  saveColumnWidths as saveColumnWidthsBase,
  updateFilterNode,
  useColumnWidths as useColumnWidthsBase,
  type ColumnVisibility,
  type ColumnWidths,
  type ExportMenuOption,
  type FieldDefinition,
  type FieldOption,
  type FieldType,
  type FilterCondition,
  type FilterConjunction,
  type FilterGroup,
  type FilterNode,
  type FilterOperator,
  type FilterPill,
  type GetValueFn,
  type AlertCountBadgeProps,
  type AlertDotProps,
  type GroupByOption,
  type GroupBySelectProps,
  type HoverHelpProps,
  type SearchInputProps,
  type SearchToken,
  type SortDirection,
  type SortSpec,
  type TablePageShellProps,
  type UseColumnWidthsOptions,
  type UseColumnWidthsResult,
} from '@cottage/design-system/internal-tooling/ui'

export const BOOKKEEPER_APP_KEY = 'bookkeeper'

const persistence = createTablePersistence(BOOKKEEPER_APP_KEY)

export const getDefaultColumnVisibility = persistence.getDefaultColumnVisibility
export const loadColumnVisibility = persistence.loadColumnVisibility.bind(persistence)
export const saveColumnVisibility = persistence.saveColumnVisibility.bind(persistence)
export const setColumnVisible = persistence.setColumnVisible.bind(persistence)
export const resetColumnVisibility = persistence.resetColumnVisibility.bind(persistence)
export const getVisibleFieldKeys = persistence.getVisibleFieldKeys

export function useColumnWidths(
  options: Omit<UseColumnWidthsOptions, 'appKey'>
): UseColumnWidthsResult {
  return useColumnWidthsBase({ ...options, appKey: BOOKKEEPER_APP_KEY })
}

export function loadColumnWidths(
  pageKey: string,
  columnKeys: string[],
  defaults: ColumnWidths,
  minWidth?: number
): ColumnWidths {
  return loadColumnWidthsBase(BOOKKEEPER_APP_KEY, pageKey, columnKeys, defaults, minWidth)
}

export function saveColumnWidths(pageKey: string, widths: ColumnWidths): void {
  saveColumnWidthsBase(BOOKKEEPER_APP_KEY, pageKey, widths)
}

export function readStoredColumnWidths(pageKey: string): ColumnWidths {
  return readStoredColumnWidthsBase(BOOKKEEPER_APP_KEY, pageKey)
}

export {
  ActiveFilterPillBar,
  AlertCountBadge,
  AlertDot,
  ColumnPicker,
  ColumnResizeHandle,
  DEFAULT_MIN_COLUMN_WIDTH,
  DrawerShell,
  FilterBuilderDrawer,
  FilterConditionRow,
  MAX_FILTER_NESTING_DEPTH,
  OPERATORS_BY_FIELD_TYPE,
  OPERATOR_LABELS,
  SearchInput,
  SectionHeader,
  SortBuilder,
  TablePageShell,
  TableToolbar,
  appendChildToGroup,
  applySorts,
  canNestDeeper,
  clampColumnWidth,
  clearFilterTree,
  columnVisibilityStorageKey,
  columnWidthsStorageKey,
  countFilterConditions,
  createBooleanSearchEvaluator,
  createEmptyFilterGroup,
  createFilterCondition,
  createId,
  evaluateBooleanSearch,
  evaluateCondition,
  evaluateFilterTree,
  filterRows,
  generateFilterPills,
  getDefaultOperatorForFieldType,
  getFilterTreeDepth,
  getOperatorsForFieldType,
  getStickyLeftOffset,
  getTotalColumnWidth,
  GroupBySelect,
  HoverHelp,
  isFilterCondition,
  isFilterGroup,
  isRenderableFilterNode,
  matchTerm,
  mergeColumnWidths,
  operatorAcceptsMultipleValues,
  operatorRequiresValue,
  parseSearchQuery,
  removeFilterNode,
  removeFilterPill,
  resolveFieldValue,
  updateFilterNode,
  type ColumnVisibility,
  type ColumnWidths,
  type ExportMenuOption,
  type FieldDefinition,
  type FieldOption,
  type FieldType,
  type FilterCondition,
  type FilterConjunction,
  type FilterGroup,
  type FilterNode,
  type FilterOperator,
  type FilterPill,
  type GetValueFn,
  type AlertCountBadgeProps,
  type AlertDotProps,
  type GroupByOption,
  type GroupBySelectProps,
  type HoverHelpProps,
  type SearchInputProps,
  type SearchToken,
  type SortDirection,
  type SortSpec,
  type TablePageShellProps,
  type UseColumnWidthsOptions,
  type UseColumnWidthsResult,
}
